// Every rule number, from docs/rules.pdf (CGE, July 2015).

export const GRID = 25; // "Randomly choose 25 codenames ... 5-by-5 grid" (p2)
export const GRID_SIDE = 5;

// The key: 9 for the starting team ("The starting team has 9 words to
// guess. The other team has 8", p3), 7 innocent bystanders, 1 assassin (p3).
export const STARTING_TEAM_AGENTS = 9;
export const OTHER_TEAM_AGENTS = 8;
export const BYSTANDERS = 7;
export const ASSASSINS = 1;

export const TEAMS = ['red', 'blue'];

// Clue numbers offered in the UI: 0-9 plus unlimited (both expert clues,
// p7). 0 and unlimited both mean "guess as many as you want, at least one".
export const MAX_CLUE_NUMBER = 9;
export const UNLIMITED = 'unlimited';

// Guesses allowed for a numbered clue: the number "plus one extra" (p5,
// "You are allowed only one extra guess").
export const extraGuess = (count) => count + 1;
